module.exports = __webpack_public_path__ + "static/vinos-01-e5e19cecf14e579a11e457a48d031c11.jpg";